import React from "react";
import PropTypes from "prop-types";
import { StyledWrapper, StyledLabel } from "./_styled";
import { Type } from "@ebscois/react-component-library";

const AboutTabRow = ({ label, value, id }) => {
  return (
    <StyledWrapper data-testid={id}>
      <StyledLabel
        element="h6"
        data-testid="about-tab-row-label"
        fontWeight="semibold"
        textTransform="uppercase"
        color="secondary"
      >
        {label}
      </StyledLabel>
      <Type fontSize="lg" data-testid="about-tab-row-value">
        {value}
      </Type>
    </StyledWrapper>
  );
};

AboutTabRow.propTypes = {
  label: PropTypes.string,
  value: PropTypes.element,
  id: PropTypes.string,
};

AboutTabRow.displayName = "AboutTabRow";
export default AboutTabRow;
